import { Lock, Shield, HeartHandshake } from "lucide-react";
import { FeaturesGrid } from "../shared/FeaturesGrid";

export const HomeFeatures = () => {
  const features = [
    {
      icon: Lock,
      title: "Security System Discounts",
      description: "Save on premiums with monitored security systems."
    },
    {
      icon: Shield,
      title: "Identity Theft Protection",
      description: "Added security for your personal information."
    },
    {
      icon: HeartHandshake,
      title: "Dedicated Support",
      description: "Personal assistance throughout your coverage journey."
    }
  ];

  return (
    <FeaturesGrid
      title="Expert Home Insurance Support"
      description="Our dedicated team ensures you receive the best coverage and support for your home insurance needs."
      features={features}
    />
  );
};